import React from 'react';
import { connect } from 'react-redux';

import { UserAccountId } from 'api/UserAccount/model/UserAccountId';

import { SignUpFormDispatch, SignUpFormActions } from 'shared/components/SignUpOrSignIn/SignUpForm/actions';
import { signUpFormFieldName } from 'shared/components/SignUpOrSignIn/SignUpForm/reducers';
import { SignUpForm } from 'shared/components/SignUpOrSignIn/SignUpForm/SignUpForm';
import { ISignUpOptionsState } from 'shared/components/SignUpOrSignIn/SignUpOptions/reducers';

import { SignUpAndLoginDispatch } from '../SignUpAndLoginButtons/actions';
import { ISignUpAndLoginButtonsState } from '../SignUpAndLoginButtons/reducers';
import { GetStartedFormActions } from './actions';

import { PathUtils } from 'shared/utils/pathUtils';

import 'shared/css/MakeItSpin.scss';

interface IGetStartedFormProps {
    signUpAndLoginButtonsState : ISignUpAndLoginButtonsState;
    signUpOptionsState : ISignUpOptionsState;
}

interface IConnectedGetStartedFormProps extends IGetStartedFormProps {
    dispatch : SignUpFormDispatch & SignUpAndLoginDispatch;
}

class GetStartedForm extends React.Component<IConnectedGetStartedFormProps, object> {

    public render() {
        const {
            signUpAndLoginButtonsState,
            signUpOptionsState,
        } = this.props;

        if (typeof(signUpAndLoginButtonsState.loggedInUser) === 'undefined') {
            return (
                <div>
                    <span className="bevicon bevico-spinner2 make-it-spin loading-spinner"/>
                </div>
            );
        }

        if (signUpAndLoginButtonsState.loggedInUser) {
            const userName = signUpAndLoginButtonsState.loggedInUser.userInfo ? ', ' + signUpAndLoginButtonsState.loggedInUser.userInfo.firstName : '';
            return (
                <div className="get-started-form">
                    <p>Welcome back{ userName }!</p>
                    <p>
                        <a className="btn" href={ PathUtils.getAbsolutePathForRequest(`/start_free_trial${ window.location.search }`) }>Start Free Trial</a>
                    </p>
                    <p>You already have a user account with BevSpot. You can still start a new free trial above or go to your <a href={ PathUtils.getAbsolutePathForRequest('/user') }>user dashboard</a>.</p>
                </div>
            );
        } else {
            return (
                <div className="get-started-form">
                    <SignUpForm
                        headerTitle={ null }
                        headerMessage={ null }
                        signUpFormState={ signUpOptionsState.signUpOptionsForm.signUpForm }
                        onFormFieldChange={ this.onFormFieldChange }
                        onFormFieldBlur={ this.onFormFieldBlur }
                        additionalUserFieldsAreShown={ false }
                        additionalRetailerFieldsAreShown={ false }
                        additionalRetailerFieldsAreRequired={ false }
                        submitButtonContents="START FREE TRIAL"
                        onSubmit={ this.onSignUpAndCreateRetailerFormSubmit }
                        setAddressFormField={ this.doNothing }
                    />
                </div>
            );
        }
    }

    private readonly onFormFieldChange = (field : signUpFormFieldName, value : string | boolean) => {
        return this.props.dispatch(SignUpFormActions.onFormFieldChange(field, value));
    }

    private readonly  onFormFieldBlur = (field : signUpFormFieldName, value : string | boolean) => {
        return this.props.dispatch(SignUpFormActions.onFormFieldBlur(field, value));
    }

    private readonly onSignUpAndCreateRetailerFormSubmit = () => {
        const {
            dispatch,
            signUpOptionsState,
        } = this.props;

        dispatch(SignUpFormActions.onSubmit(signUpOptionsState.signUpOptionsForm.signUpForm, false, false, true))
        .then((userAccountIdentifier : UserAccountId | void) => {
            if (userAccountIdentifier) {
                const validationInputDataByFieldName = signUpOptionsState.signUpOptionsForm.signUpForm.validationInputDataByFieldName;
                dispatch(GetStartedFormActions.onSuccessfulUserSignUp(
                    userAccountIdentifier,
                    {
                        firstName : validationInputDataByFieldName.firstName.value,
                        lastName : validationInputDataByFieldName.lastName.value,
                        emailAddress : validationInputDataByFieldName.emailAddress.value,
                        phone : validationInputDataByFieldName.phone.value,
                        barName : validationInputDataByFieldName.barName.value,
                        country : validationInputDataByFieldName.country.value,
                        city : validationInputDataByFieldName.city.value,
                        state : validationInputDataByFieldName.state.value,
                        streetAddressLine1 : validationInputDataByFieldName.streetAddressLine1.value,
                        streetAddressLine2 : validationInputDataByFieldName.streetAddressLine2.value,
                        zipCode : validationInputDataByFieldName.zipCode.value,
                        optionalZipCode : validationInputDataByFieldName.optionalZipCode.value,
                        subscribeToBlog : validationInputDataByFieldName.subscribeToBlog.value,
                    }
                ))
                .then(() => {
                    window.location.href = PathUtils.getAbsolutePathForRequest(`/start_free_trial${ window.location.search }`);
                });
            }
        });
    }

    private readonly doNothing = () => undefined;
}

const mapStateToProps = (state : IGetStartedFormProps) : IGetStartedFormProps => {
    return {
        signUpAndLoginButtonsState : state.signUpAndLoginButtonsState,
        signUpOptionsState : state.signUpOptionsState,
    };
};

export const ConnectedGetStartedForm = connect<IGetStartedFormProps, object, object, IGetStartedFormProps>(mapStateToProps)(GetStartedForm);
